import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchData = (url, config) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const requestConfig = {
          ...config,
          timeout: config?.timeout || 60000, 
        };
        
        const response = await axios.get(url, requestConfig);
        setData(response.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
        if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
          console.error('Request timeout - API took too long to respond');
          setError({
            ...error,
            message: 'Request timeout. The server is taking too long to respond. Please check if the backend server is running.',
            isTimeout: true
          });
        } else {
          setError(error);
        }
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [url, config]);

  return { data, loading, error };
};
export default useFetchData;
